const cleanSegment = (value) => {
  if (value === null || value === undefined) return '';
  const withoutControlChars = Array.from(String(value))
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join('');
  return withoutControlChars
    .replace(/<[^>]*>/g, '')
    .replace(/&/g, ' and ')
    .replace(/[<>:"/\\|?*]/g, ' ')
    .replace(/[^\w\s.-]/g, ' ')
    .replace(/[_\s.-]+/g, ' ')
    .trim();
};

const formatWord = (word) => {
  if (!word) return '';
  if (/^[A-Z0-9]{2,}$/.test(word)) return word;
  if (/[a-z][A-Z]/.test(word)) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

const formatSegment = (value, fallback, maxWords = 8) => {
  const words = (cleanSegment(value) || fallback)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, maxWords)
    .map(formatWord);
  return words.join('_') || fallback;
};

const formatDate = (date = new Date()) => {
  const validDate = date instanceof Date && !Number.isNaN(date.getTime())
    ? date
    : new Date();
  const year = validDate.getFullYear();
  const month = String(validDate.getMonth() + 1).padStart(2, '0');
  const day = String(validDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const buildResumeDownloadFilename = ({
  formData = {},
  date = new Date(),
} = {}) => {
  const firstName = formatSegment(formData.personalInfo?.firstName, 'Candidate', 2);
  const lastName = formatSegment(formData.personalInfo?.lastName, 'Resume', 2);
  const aiTitle = formData.aiInferredResumeTitle || formData.suggestedResumeTitle || '';
  const title = formatSegment(aiTitle, 'Resume', 10);
  return `${firstName}_${lastName}_${title}_${formatDate(date)}.docx`;
};
